module.exports = __webpack_public_path__ + "images/ico-task-act.svg?3757400106dffb77f197afc6c4ed2aa3";